<template>
  <!-- Account card at the bottom of the sidebar (US 9372) -->
  <div class="sb-menu-anchor sb-account">
    <button type="button"
            class="sb-account__card"
            :class="{ 'sb-account__card--open': open }"
            :aria-expanded="open ? 'true' : 'false'"
            :aria-label="$t('app_nav.account_menu')"
            @click="open = !open"
            qid="navbar-user-dropdown"
    >
      <img :src="avatar"
           class="sb-account__avatar"
           alt=""
           qid="profile-photo"
      >
      <span class="sb-account__text" v-if="!compact">
        <span class="sb-account__name">{{ getUser.name }}</span>
        <span class="sb-account__email">{{ getUser.email }}</span>
      </span>
      <font-awesome-icon icon="sort" class="sb-account__chevron" v-if="!compact"/>
    </button>

    <div class="sb-menu-backdrop" v-if="open" @click="open = false"></div>
    <div class="sb-menu sb-menu--account"
         v-if="open"
         role="menu"
         @keydown.esc="open = false"
         @click="open = false"
    >
      <router-link v-if="getUser.slug"
                   :to="{ name: 'profile', params: { slug: getUser.slug }}"
                   class="sb-menu__item"
                   role="menuitem"
                   qid="user-dropdown-profile-link"
      >
        <img :src="avatar" class="sb-menu__avatar" alt="">
        <span class="sb-menu__name">{{ $t('top_nav.user_dropdown.my_profile') }}</span>
      </router-link>
      <router-link v-if="getUser.isAdmin"
                   to="/administration"
                   class="sb-menu__item"
                   role="menuitem"
                   qid="user-dropdown-administration-link"
      >
        <font-awesome-icon icon="cog" class="sb-menu__icon"/>
        <span class="sb-menu__name">{{ $t('top_nav.user_dropdown.administration') }}</span>
      </router-link>
      <div class="sb-menu__sep"></div>
      <button type="button"
              class="sb-menu__item"
              role="menuitem"
              @click="logout"
              qid="user-dropdown-logout"
      >
        <font-awesome-icon icon="sign-out-alt" class="sb-menu__icon"/>
        <span class="sb-menu__name">{{ $t('top_nav.user_dropdown.logout') }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import piincHttp from '@/util/configureAxios.js';
import {userAvatarUrl} from '@/util/userAvatar.js';

export default {
  name: 'AccountMenu',
  props: {
    compact: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      open: false
    }
  },
  computed: {
    getUser() {
      return this.$store.state.user
    },
    avatar() {
      return userAvatarUrl(this.getUser, true);
    }
  },
  methods: {
    logout() {
      let self = this;
      piincHttp.post('logout').then(function() {
        localStorage.removeItem('token')
        localStorage.removeItem('client')
        localStorage.removeItem('clientObject')
        self.$store.commit('storeHistoryPage', '');
        setTimeout(function() {
          window.location.href = '/login'
        }, 500);
      }, function(error) {
        alert(error)
      })
    }
  }
}
</script>
